import { createStyles, makeStyles } from '@material-ui/styles';
import * as React from 'react';
import { FC } from 'react';
import mediaQueries from 'src/constants/responsive';
// import spacing from 'src/constants/spacing';
import { secondaryColor } from 'src/constants/stylesheet';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
      width: '100%',
      flex: '0 0 100%',

      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: '50%',
        width: '100vw',
        transform: 'translateX(-50%)',
        height: 1,
        backgroundColor: secondaryColor
      },

      [mediaQueries.Mobile]: {
        // paddingBottom: spacing.Gutter.Mobile,
        paddingBottom: 15,
      },
      [mediaQueries.Tablet]: {
        // paddingBottom: spacing.Gutter.Tablet,
        paddingBottom: 15,
      },
      [mediaQueries.Laptop]: {
        // paddingBottom: spacing.Gutter.Laptop,
        paddingBottom: 15,
      },
      [mediaQueries.Desktop]: {
        // paddingBottom: spacing.Gutter.Desktop,
        paddingBottom: 15,
      },
    },
  }));

export type PanelSeparatorImage = PanelSeparatorDto;

type Props = PanelSeparatorImage;

const PanelSeparator: FC<Props> = () => {
  const cls = useStyles();

  return (
    <div className={cls.root} />
  );
};

export default PanelSeparator;


// WEBPACK FOOTER //
// ./src/Components/Panels/PanelSeparator.tsx